import React,{useState,useEffect} from 'react'
import { Button, Divider, Form, Grid, Segment,Message } from 'semantic-ui-react'
import {useMediaQuery, createMuiTheme } from '@material-ui/core'
import {Typography} from '@material-ui/core'
import CSS from './DividerForm.module.css'
import { connect } from 'react-redux';
import { authAction,signOut,reducerInitial } from '../../Store/Action';


function DividerForm(props) {
    const theme = createMuiTheme({
        breakpoints : {
            values : {
                xs : 300,
                sm : 766,
                md : 800,
                lg : 1280,
                xl : 1920
            }
        }
    })
    const isMatch = useMediaQuery(theme.breakpoints.up("sm"))
    const match1 = useMediaQuery(theme.breakpoints.between("sm","md"))
    
    const initialState = {
      email : '',
      password : '',
  }
  const [state, setstate] = useState(initialState)  
 
  const getDets=(e)=>{
    setstate(prevState=>({...prevState,[e.target.name] : e.target.value  }))
  }
  
  const submitDets=(e)=>{
    e.preventDefault()
    
    props.authentication(state.email,state.password,props.history)

    
    setstate(prevState=>({ email : '',password : ''}))
            
    }
    const Back=()=>{
      props.history.goBack()
    }

    useEffect(() => {
      window.scrollTo(0,0)
      if(props.state_data.isAuth===true) props.logout(props.history)
      
      props.initReducer()
    },[])


    const gotoEdit=()=>{
      props.history.push("/edit/vendor")
    }

    const msg= props.state_data.error.slice(5)
    
    return (
        
        <div className='container mt-5 mb-5 pt-3 pb-3'>
        <Segment placeholder>
        <Grid columns={2} relaxed='very' stackable>
          <Grid.Column>
          <Typography className="mt-5" color='textSecondary' align="center" variant="h5" >
                Login for Vendor Registration
            </Typography>
            <Form error success className={CSS.form}>
              <Form.Input
                onChange={getDets}
                value={state.email}
                name="email"
                icon='user'
                iconPosition='left'
                label='Username'
                className={CSS.input}
                placeholder='Username'
              />
              <Form.Input
                onChange={getDets}
                value={state.password}
                name="password"
                icon='lock'
                iconPosition='left'
                label='Password'
                type='password'
                className={CSS.input}
                placeholder="Password"
              />
              <Typography color='textSecondary' align="center" display="block"  variant="caption" >
               Use the vendor username and password provided to you.
              </Typography>
              
                    {
                        (props.state_data.error === '') ? " " :
                        <Message
                          error
                          header='Sign-in Failed !'
                          content={msg}
                        />  
                         
                        
                    }
                {
                    props.state_data.isAuth ?  
                    <Message
                    success
                    header='Sign-in Success'
                    content="Please wait ! Redirecting to Register Page"
                    />
                    :
                    ""
                }
              
            <div className="d-flex" id={CSS.btn} style={{margin : '2rem auto'}}>
            <Button onClick={Back} inverted fluid color="grey" style={{color : "grey",marginRight : '1rem' }}>Back</Button>
            <Button onClick={submitDets} inverted fluid color="green">Login</Button>
            </div>                
            </Form>
            <Grid.Column verticalAlign='middle'>
            { 
            (!isMatch)  ? 
             <Divider horizontal>Or</Divider>
            : ''
            
            }
            </Grid.Column>
          </Grid.Column>
          <Grid.Column verticalAlign='middle'>
            <Button onClick={gotoEdit} content="Edit your vendor details" icon='signup' size='medium' primary />
          </Grid.Column>
        </Grid>
                {
                    (!isMatch) ? 
                    " ":
                    (match1 ) ? 
                     <Divider vertical>Or</Divider>
                     :
                     <Divider vertical>Or</Divider>                    
                }
      </Segment>
      </div>
    )
}

const mapStateToProps =state=>({
  state_data : state.reducer
})

const mapDispatchToProps =({
  authentication : authAction,
  logout : signOut,
  initReducer : reducerInitial
})


export default connect(mapStateToProps,mapDispatchToProps)(DividerForm)
